/* src/app/shared/common-ui/lib/popover/dropdown/dropdown.less */
.dropdown {
  display: inline-block;
  position: relative;
  font-size: 1.2rem;
  color: var(--color-default-text);
}
.dropdown.dropdown > .dropdown-item {
  padding-left: 1rem;
  padding-right: 1rem;
}
.dropdown.dropdown.dropdown-item {
  padding: inherit;
}
.dropdown button {
  letter-spacing: inherit;
}
.dropdown button:hover {
  color: inherit;
  background: inherit;
}
.dropdown-menu {
  display: flex;
  flex-direction: column;
  position: absolute;
  top: 100%;
  left: 0;
  margin: 0.5rem 0;
  background: var(--color-dropdown-popup-background);
  box-shadow:
    0 0.8rem 1rem 1rem rgba(0, 0, 0, 0.014),
    0 0.3rem 1.4rem 0.2rem rgba(0, 0, 0, 0.12),
    0 0.5rem 0.5rem -0.3rem rgba(0, 0, 0, 0.2);
  outline: none;
  visibility: hidden;
  z-index: 2000;
}
.dropdown-menu .dropdown-item {
  display: block;
  position: relative;
  height: auto;
  width: 100%;
  margin: 0;
  padding-left: 2.5rem;
  padding-top: 0.3rem;
  padding-right: 2.5rem;
  padding-bottom: 0.3rem;
  line-height: inherit;
  text-transform: none;
  color: var(--color-default-text);
  overflow: hidden;
  text-overflow: ellipsis;
  background: transparent;
  border: 0;
  border-color: transparent;
  box-shadow: none;
  cursor: pointer;
  outline-style: none;
  text-align: left;
  white-space: nowrap;
}
.dropdown-menu .dropdown-item.active {
  color: var(--color-default-static-text);
  background: var(--color-default-focus);
}
.dropdown-menu .dropdown-item:hover {
  color: var(--color-default-static-text);
  background-color: var(--color-default-selected-background);
  text-decoration: none;
}
.dropdown-menu .dropdown-item.disabled,
.dropdown-menu .dropdown-item:disabled {
  cursor: not-allowed;
  opacity: 0.3;
  -webkit-user-select: none;
  user-select: none;
}
.dropdown-menu .dropdown-item.expandable {
  margin-right: 1rem;
  padding-right: 0.5rem;
}
.dropdown-menu .dropdown-item.expandable:before {
  position: absolute;
  right: 0;
  height: 1.2rem;
  width: 1.2rem;
  margin-top: 0.55rem;
  margin-right: 1.2rem;
  background-image: url(data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2012%2012%22%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cstyle%3E.cls-1%7Bfill%3A%239a9a9a%3B%7D%3C%2Fstyle%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Ctitle%3ECaret%3C%2Ftitle%3E%0A%20%20%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M6%2C9L1.2%2C4.2a0.68%2C0.68%2C0%2C0%2C1%2C1-1L6%2C7.08%2C9.84%2C3.24a0.68%2C0.68%2C0%2C1%2C1%2C1%2C1Z%22%2F%3E%0A%3C%2Fsvg%3E%0A);
  content: "";
  transform: rotate(-90deg);
}
.dropdown-menu .dropdown-divider {
  margin: 0.5rem 0;
  border-bottom: 0.1rem solid var(--color-default-separator-light);
}
.dropdown-menu .dropdown a:visited {
  text-decoration: none;
}
.dropdown-menu .dropdown a:link {
  text-decoration: none;
}
.dropdown-menu .dropdown > * {
  white-space: nowrap;
}
.dropdown.open.menu > .dropdown-menu {
  padding: 0.5rem 0;
}
.dropdown.open.menu > .dropdown-menu .dropdown-item {
  padding-left: 4rem;
}
.dropdown.open > .dropdown-menu,
.dropdown.open > .dropdown-menu-wrapper > .dropdown-menu {
  visibility: visible;
}
.dropdown.open > .dropdown-menu,
.dropdown.open > .dropdown-menu-wrapper > .dropdown-menu {
  visibility: visible;
}
.dropdown.bottom-left > .dropdown-menu,
.dropdown.bottom-right > .dropdown-menu {
  top: 100%;
  bottom: auto;
}
.dropdown.bottom-left > .dropdown-menu {
  left: 0;
  right: auto;
}
.dropdown.bottom-right > .dropdown-menu {
  left: auto;
  right: 0;
}
.dropdown.top-left > .dropdown-menu,
.dropdown.top-right > .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin: 0 0 -2.5 -2.5;
}
.dropdown.top-left > .dropdown-menu {
  left: 0;
  right: auto;
}
.dropdown.top-right > .dropdown-menu {
  left: auto;
  right: 0;
}
.dropdown.left-top > .dropdown-menu,
.dropdown.left-bottom > .dropdown-menu {
  left: auto;
  right: 100%;
  margin: 0 -2.5 -2.5 0;
}
.dropdown.left-bottom > .dropdown-menu {
  top: 0;
  bottom: auto;
}
.dropdown.left-top > .dropdown-menu {
  top: auto;
  bottom: 0;
}
.dropdown.right-top > .dropdown-menu,
.dropdown.right-bottom > .dropdown-menu {
  left: 100%;
  right: auto;
  margin: 0 0 -2.5 -2.5;
}
.dropdown.right-bottom > .dropdown-menu {
  top: 0;
  bottom: auto;
}
.dropdown.right-top > .dropdown-menu {
  top: auto;
  bottom: 0;
}
.dropdown-toggle {
  display: flex;
  align-items: center;
  padding: 0;
  color: var(--color-default-text);
  background: transparent;
  border: 0;
  opacity: inherit;
}
.dropdown-toggle:focus {
  outline: none;
  text-decoration: none;
}
.dropdown-toggle > * {
  margin: 0;
}
.toggle {
  display: flex;
}
.arrow {
  height: 1.2rem;
  width: 1.2rem;
  min-height: 1.2rem;
  min-width: 1.2rem;
  margin-left: 0.7rem;
  margin-top: 0.7rem;
  background: url(data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2012%2012%22%3E%0A%20%20%20%20%3Cdefs%3E%0A%20%20%20%20%20%20%20%20%3Cstyle%3E.cls-1%7Bfill%3A%239a9a9a%3B%7D%3C%2Fstyle%3E%0A%20%20%20%20%3C%2Fdefs%3E%0A%20%20%20%20%3Ctitle%3ECaret%3C%2Ftitle%3E%0A%20%20%20%20%3Cpath%20class%3D%22cls-1%22%20d%3D%22M6%2C9L1.2%2C4.2a0.68%2C0.68%2C0%2C0%2C1%2C1-1L6%2C7.08%2C9.84%2C3.24a0.68%2C0.68%2C0%2C1%2C1%2C1%2C1Z%22%2F%3E%0A%3C%2Fsvg%3E%0A) no-repeat;
}
/*# sourceMappingURL=dropdown.css.map */
